import React from 'react';  // eslint-disable-line

const Vimeo = () => {
    return (
        <svg width="64" height="56" viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg">
            <title>Shape</title>
            <defs>
                <linearGradient id="youtube-a" x1="49.98%" x2="49.98%" y1="0%" y2="100.03%">
                    <stop offset="0%" stopColor="#E52D27" />
                    <stop offset="100%" stopColor="#BF171D" />
                </linearGradient>
                <linearGradient id="podcast-a" x1="50%" x2="50%" y1="2.179%" y2="97.818%">
                    <stop offset="0%" stopColor="#D394F2" />
                    <stop offset="100%" stopColor="#936BFF" />
                </linearGradient>
            </defs>
            <path d="M63.97 12.916c-.286 6.242-4.637 14.789-13.053 25.637C42.215 49.885 34.853 55.55 28.83 55.55c-3.73 0-6.888-3.45-9.466-10.351L14.2 26.22c-1.915-6.898-3.97-10.351-6.165-10.351-.479 0-2.154 1.009-5.023 3.02L0 15.002a814.33 814.33 0 0 0 9.34-8.345c4.213-3.647 7.375-5.565 9.483-5.76 4.98-.479 8.046 2.932 9.197 10.235 1.244 7.878 2.104 12.779 2.588 14.697 1.435 6.536 3.015 9.8 4.74 9.8 1.34 0 3.352-2.12 6.035-6.359 2.68-4.24 4.116-7.467 4.31-9.683.382-3.66-1.055-5.494-4.31-5.494-1.532 0-3.111.354-4.736 1.052C39.792 4.822 45.8-.191 54.672.095c6.576.193 9.676 4.467 9.297 12.82" fill="#32B8E8" />
        </svg>
    );
};

export default Vimeo;
